<template>
    <article class="price-item" :class="{'price-item--bestseller': lessonType.is_bestseller}">
        <h3 class="price-item__title">{{lessonType.title}}</h3>

        <form action="/" class="price-select-form" @submit.prevent="bindSelect">
            <label class="label-select subtype-select" v-if="diffSubtypes">
                <select name="subtype"
                        v-model="selectedSubtypeIndex">
                    <option
                            v-for="(subtype, index) in lessonType.prices.types"
                            :key="index"
                            :value="index"
                    >{{subtype.title}}</option>
                </select>
            </label>

            <keep-alive>
                <SubtypeTariffSelect
                    :key="selectedSubtypeIndex"
                    :subtype="selectedSubtype"
                    @input="selectedTariff = $event"
                ></SubtypeTariffSelect>
            </keep-alive>

            <div class="price-select-form__bottom" v-if="selectedTariffObj">
                <div class="price-item__price">
                    <div class="price-old" v-if="selectedTariffObj.price_old">{{selectedTariffObj.price_old}} ₽</div>
                    <div class="price">{{selectedTariffObj.price}} ₽</div>
                </div>

                <button class="btn btn-light-green btn-lg price-record-btn">Хочу учиться</button>
            </div>
        </form>
    </article>
</template>

<script>
    import SubtypeTariffSelect from './SubtypeTariffSelect';

    export default {
        name: "LessonType",

        components: {
            SubtypeTariffSelect,
        },

        data(){
            return {
                selectedSubtypeIndex: 0,
                selectedTariff: 0,
            };
        },

        props: {
            lessonType: {
                type: Object,
                required: true,
            },
        },

        computed: {
            diffSubtypes(){
                return this.lessonType.prices.types.length > 1;
            },

            selectedSubtype(){
                return this.lessonType.prices.types[this.selectedSubtypeIndex];
            },

            selectedTariffObj(){
                if(!this.selectedSubtype)
                    return;

                return this.selectedSubtype.tariffs[this.selectedTariff];
            },
        },

        methods: {
            bindSelect(){
                let title = `Заявка на обучение`;
                let subtitle = `${this.lessonType.title}${this.diffSubtypes ? ', ' + this.selectedSubtype.title : ''}${this.selectedTariffObj ? ', ' + this.selectedTariffObj.title : ''}`;
                openRecordFormModal({title, subtitle});
            },
        },
    }
</script>

<style scoped>
    .subtype-select{
        margin-bottom: 15px;
    }
</style>